import type { GUID } from "#public"

import { StringToUInt8 } from "../bytes/StringToUInt8"
import { JSONEncode } from "../encoding/JSONEncode"
import { UInt8Hash } from "./UInt8Hash"

/**
 * Computes SHA-256 hash of any JSON-serializable value.
 *
 * Serializes the value to JSON (with bigint support) then computes hash.
 *
 * @param value - Any JSON-serializable value
 * @returns GUID hash
 *
 * @example
 * ```ts
 * import { JSONHash } from "@pdfking/tfunc"
 *
 * JSONHash({ name: "John", age: 30 })
 * ```
 */
export const JSONHash = (...value: any): GUID =>
  UInt8Hash([StringToUInt8(JSONEncode(value, { bigint: true }))])
